import { TransposeWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Transpose')
export class TransposeConnectorProvider extends ConnectorProvider<TransposeWorkflowNode> {}
